import React, { useContext, useState, useEffect, createContext } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, db } from "../lib/firebase";
import { doc, getDoc } from "firebase/firestore";

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        try {
           const userDocRef = doc(db, "users", currentUser.uid);
           const userDoc = await getDoc(userDocRef);

           if (userDoc.exists()) {
             const userData = userDoc.data();
             setUser({ ...currentUser, ...userData });
           } else {
             setUser(currentUser);
           }
        } catch (error) {
          console.error("Error fetching user data from Firestore:", error);
          setUser(currentUser);
        }
      } else {
        setUser(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const getIdToken = async () => {
    if (!auth.currentUser) {
      throw new Error("No user is signed in.");
    }
    return await auth.currentUser.getIdToken();
  };

  const logout = () => signOut(auth);

  if (loading) {
    return null;
  }

  return (
    <AuthContext.Provider value={{ user, logout, loading, getIdToken }}>
      {children}
    </AuthContext.Provider>
  );
};